document.addEventListener('DOMContentLoaded', function () {
  const countdownWrapper = document.querySelector('.countdown-condensed-wrapper');
  const expirationDateStr = countdownWrapper.getAttribute('data-expiration-date');

  if (!expirationDateStr) {
    console.error('Expiration date not found in HTML');
    return;
  }

  const expirationDate = new Date(expirationDateStr);

  function updateCountdown() {
    const now = new Date();
    const diff = expirationDate - now;

    if (diff <= 0) {
      clearInterval(interval);
      document.getElementById('countdown-days').textContent = '00';
      document.getElementById('countdown-hours').textContent = '00';
      document.getElementById('countdown-minutes').textContent = '00';
      document.getElementById('countdown-seconds').textContent = '00';
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById('countdown-days').textContent = String(days).padStart(2, '0');
    document.getElementById('countdown-hours').textContent = String(hours).padStart(2, '0');
    document.getElementById('countdown-minutes').textContent = String(minutes).padStart(2, '0');
    document.getElementById('countdown-seconds').textContent = String(seconds).padStart(2, '0');
  }

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
});
